// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__BC-Xl","employee-header-item":"Header_employee-header-item__CTOyW"};